let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aZVXm")).then(() => parcelRequire('aoEr0'));